<template>
  <v-dialog v-model="dialog" max-width="1000px" persistent scrollable>
    <template v-slot:activator="{ on }">
      <a v-on="on">
        <primary-button small class="mr-1" height="35px">View</primary-button>
      </a>
    </template>
    <dialog-card :title="title" @close="dialog = false">
      <v-row class="mb-5">
        <v-col cols="3">
          <label class="body-small">Affiliate</label>
          <div class="body-small--medium black--text">{{ item.name }}</div>
        </v-col>
        <v-col cols="3">
          <label class="body-small">Week</label>
          <div class="body-small--medium black--text">{{ item.weekName }}</div>
        </v-col>
        <v-col cols="3">
          <label class="body-small">Commission Owed</label>
          <div class="body-small--medium black--text">
            {{ formatPrice(item.owed) }}
          </div>
        </v-col>
      </v-row>
      <static-table-view
        :list="list"
        :headers="headers"
        :show-select="item.payout !== 'Paid'"
        v-model="selected"
        class="affiliate-weekly-commissions-view"
      >
        <div v-if="item.payout !== 'Paid'" class="flex-1 mb-5" slot="left">
          <div class="d-flex mt-5" v-if="hasEdit('affiliates')">
            <input-field
              type="number"
              label="Commision%"
              v-model="commission_rate"
            />
            <secondary-button
              :loading="isLoading"
              :disabled="selected.length == 0"
              class="mt-7 ml-3"
              @click="applyCommission()"
              >Apply To Selection</secondary-button
            >
          </div>
          <affiliate-weekly-payout
            :selected="selected"
            :disabled="selected.length == 0"
            @onPayout="$emit('onPayout')"
            type="button"
            :item="item"
          />
        </div>
        <template v-slot:item.amount="{ value, item }">
          <span :class="{'current': item.isCurrent}">{{ formatPrice(value || 0) }}</span>
        </template>
        <template v-slot:item.commission="{ value }">
          {{ formatPrice(value) }}</template
        >
        <template v-slot:item.commission_rate="{ value }">
          {{ value }}%</template
        >
        <template v-slot:item.paid_at="{ value }">
          {{ formatDate(value) }}</template
        >
      </static-table-view>
      <div slot="footer" class="d-flex">
        <close-button @click="dialog = false">Close</close-button>
      </div>
    </dialog-card>
  </v-dialog>
</template>

<script>
import {getHeaders} from "@/assets/utils/common.utils";
import CloseButton from "../ui/buttons/CloseButton.vue";
import DialogCard from "../ui/DialogCard.vue";
import StaticTableView from "../ui/StaticTableView.vue";
import moment from "moment-timezone";
import PrimaryButton from "../ui/buttons/PrimaryButton.vue";
import AffiliateWeeklyPayout from "./AffiliateWeeklyPayout.vue";
import InputField from "@/components/ui/form/InputField.vue";
import SecondaryButton from "@/components/ui/buttons/SecondaryButton.vue";
import transactionMixin from "@/mixins/transaction.mixin";

export default {
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    affiliate: {
      type: Object,
      default: () => ({}),
    },
    unpaidTransactions: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    SecondaryButton,
    InputField,
    DialogCard,
    CloseButton,
    StaticTableView,
    PrimaryButton,
    AffiliateWeeklyPayout,
  },
  data() {
    return {
      dialog: false,
      isLoading: false,
      selected: [],
      commission_rate: 0,
    };
  },
  mixins: [transactionMixin],
  computed: {
    affiliateId() {
      return this.$route.params.id;
    },
    list() {
      let list = this.item.history.map((i) => ({
        ...i,
        isCurrent: true,
        isSelectable: i.payout == false,
      }));

      list = list.concat(this.unpaidTransactions.filter(t => {
        const createdAt = new Date(t.created_at);
        const startWeek = new Date(this.item.startWeek);
        return !list.find(l => l.id === t.id || (createdAt >= startWeek));
      }).map(i => ({
        ...i,
        isSelectable: i.payout == false,
      })));

      return list;
    },
    title() {
      let title = `The following commission for the week of ${moment(
        this.item.startWeek
      ).format("MMM DD YYYY")}`;
      if (this.item.payout === "Paid") return `${title} already paid`;
      return `${title}  are ready to be paid`;
    },
    headers() {
      let doc = {
        client_name: "Client",
        created_at: "Date",
        amount: "Transaction Amount",
        commission: "Comission Amount",
        commission_rate: "Commission %",
      };
      return getHeaders(doc);
    },
  },
  watch: {
    dialog(val) {
      if (val) {
        this.commission_rate = (this.affiliate.commission_rate || 0) * 100;
      }
    },
  },
  methods: {
    afterApplyCommission() {
      this.$emit("onPayout");
    },
  },
};
</script>

<style>
.affiliate-weekly-commissions-view tbody tr:not(:has(td > span.current)) {
  background: #fff4e5;
}
</style>
